import React from 'react';
import PropTypes from 'prop-types';
import {withStore, withScreenCheck} from '../hoc';
import Navbar from '../components/Navbar';
// import Header from '../components/Header';
import Body from '../components/Body';
import Footer from '../components/Footer';
import FormOffer from '../components/FormOffer';
/**
 * NewOfferPage
 */
class NewOfferPage extends React.Component {
  static displayName = 'NewOfferPage';
  static propTypes = {
    stores: PropTypes.object.isRequired,
    currentPage: PropTypes.object.isRequired,
  };
  static defaultProps = {};

  /**
   * @override
   */
  render() {
    return (
      <div className="NewOfferPage">
        <Navbar {...this.props} />
        <Body {...this.props}>
          <FormOffer {...this.props} />
        </Body>
        <Footer {...this.props} />
      </div>
    );
  }
}
export default withStore(withScreenCheck(NewOfferPage));



// WEBPACK FOOTER //
// ./src/pages/NewOfferPage.js